export const TEST_ID = 'errorBoundary';
